import { REACT_APP_ENV } from '../../constants';

/**
 * Feature flag to enable Sentry debug mode in stage/dev environments
 * Can be enabled via URL parameter: ?sentryDebug=true
 */
export const isSentryDebugEnabled = (): boolean => {
  // Only allow in stage/dev environments
  const isAllowedEnv = ['stage', 'development', 'local'].includes(
    REACT_APP_ENV,
  );

  if (!isAllowedEnv) {
    return false;
  }

  // Check URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('sentryDebug') === 'true';
};
